import { UserAuthorityTypes } from "../types";
import { UserInterfaceAccessGuardProps } from "./types";
import { useUserInterfaceAccessGuard } from "./hooks";

export const UserInterfaceAccessGuard = ({
  children,
  hiddenFor,
  authorities,
  fallback = null,
}: UserInterfaceAccessGuardProps) => {
  const { isBankForBanksUser, currentUserInfo } = useUserInterfaceAccessGuard();

  const TargetComponent = <>{children}</>;

  switch (hiddenFor) {
    case "authorities": {
      return authorities?.includes(
        currentUserInfo.userAuthority as UserAuthorityTypes
      )
        ? fallback
        : TargetComponent;
    }

    case "bank-for-banks": {
      return isBankForBanksUser ? fallback : TargetComponent;
    }

    default: {
      return TargetComponent;
    }
  }
};
